import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, theme } from 'antd';
import { type ReactNode, useEffect, useState } from 'react';

export interface AgencyFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters: FiltersState;
}

interface FiltersState {
  query: string;
  showInActive: boolean;
}

const AgenciesFilter = (props: AgencyFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters);
  const { token } = theme.useToken();

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS}>
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || '',
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />
    </Flex>
  );
};
AgenciesFilter.defaultProps = {
  onChange: () => {},
};
export default AgenciesFilter;
